<script>
  import { layoutMethods, customerListComputed, customerMethods} from "@/state/helpers";

  /**
   * Profile Business Data component
   */
  export default {
    page: {
      title: "Profile Business Data"
    },
    components: {
    },
    computed: {
      ...customerListComputed
    },
    data() {
      return {
        title: "Profile Business Data",
        businessId: 0,
        customerFields: [
          {
            key: 'name',
            sortable: false
          },
          {
            key: 'mobile_number',
            sortable: false,
          }
        ],
        productFields: [
          {
            key: 'product',
            sortable: false
          },
          {
            key: 'price',
            sortable: false
          },
          {
            key: 'cost',
            sortable: false,
          },
          {
            key: 'stock',
            sortable: false
          },
          {
            key: 'sold',
            sortable: false
          },
        ],
        cCurrentPage: 1,
        cPerPage: 10,
        pCurrentPage: 1,
        pPerPage: 10,
      };
    },
    methods: {
      ...layoutMethods,
      ...customerMethods,
      getCustomerList() {
        this.getBusinessCustomersList({ id: this.businessId, page: this.cCurrentPage  })
      },
      getProductList() {
        this.getBusinessProductsList({ id: this.businessId, page: this.pCurrentPage  })
      },
    },
    async mounted(){
      this.businessId = this.$route.params.bid
      this.getCustomerList()
      this.getProductList()
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
    <div class="card">
      <div class="card-body">
        <b-tabs
          content-class="p-3 text-muted"
          nav-class="nav-tabs-custom"
        >
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">Customer List</span>
            </template>
            <!-- table responsive -->
            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table striped :items="customerList" :fields="customerFields"                
                :current-page="cCurrentPage"
                responsive="sm">
                  <template #cell(name)="data">
                    <span>{{data.item.customerName}}</span>
                  </template>
                  <template #cell(mobile_number)="data">
                    <span>{{data.item.customerMobileNumber}}</span>
                  </template>                   
                </b-table>
                
              </div>
            </div>
            <!-- end table responsive -->
            <div class="row g-0 text-center" v-if="customerTotal == 0">
              <span>No data to display.</span>
            </div>
            <!-- pagination -->
            <div class="row g-0 text-center text-sm-start" v-if="customerTotal != 0 && customerTotal > 10">
              <div class="col-sm-6">
                  <div class="">
                  <p class="mb-sm-0" v-if="customerTotal >= 10">Showing {{(cCurrentPage-1) * 10 + 1}} to {{((cCurrentPage-1) * 10) + 10}} of {{customerTotal}} entries</p>
                  <p class="mb-sm-0" v-if="customerTotal < 10">Showing {{customerTotal}} of {{customerTotal}} entries</p>
                </div>
              </div>
              <!-- end col -->
              <div class="col-sm-6 text-lg-end text-sm-center">
                <div class="row">
                  <div class="d-flex justify-content-center justify-content-lg-end">
                    <div
                      class="dataTables_paginate paging_simple_numbers"
                    >
                      <!-- pagination -->
                      <b-pagination
                        class="pagination-rounded"
                        v-model="cCurrentPage"
                        :total-rows="customerTotal"
                        :per-page="cPerPage"
                        @change="cCurrentPage = $event;getCustomerList()"

                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end pagination -->
          </b-tab><!-- end of customer list-->
          <b-tab>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="far fa-user"></i>
              </span>
              <span class="d-none d-sm-inline-block">Product List</span>
            </template>
            <!-- table responsive -->
            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table striped :items="productList" :fields="productFields" responsive="sm">
                  <template #cell(product)="data">
                    <span>{{data.item.productName}}</span>
                  </template>
                    <template #cell(price)="data">
                    <span>{{data.item.productPrice | numberWithCommas}}</span>
                  </template>
                  <template #cell(cost)="data">
                    <span>{{data.item.productCost | numberWithCommas}}</span>
                  </template>
                  <template #cell(stock)="data">
                    <span>{{data.item.availableStocks}}</span>
                  </template>
                  <template #cell(sold)="data">
                    <span>{{data.item.productSold | numberWithCommas}}</span>
                  </template>
                </b-table>
              </div>
            </div>
            <!-- end table responsive -->

            <!-- pagination -->
            <div class="row g-0 text-center text-sm-start">
              <div class="col-sm-6">
                <div class="">
                  <p class="mb-sm-0" v-if="productTotal >= 10">Showing {{(pCurrentPage-1) * 10 + 1}} to {{((pCurrentPage-1) * 10) + 10}} of {{productTotal}} entries</p>
                  <p class="mb-sm-0" v-if="productTotal < 10">Showing {{productTotal}} of {{productTotal}} entries</p>
                </div>
              </div>
              <!-- end col -->
              <div class="col-sm-6 text-lg-end text-sm-center">
                <div class="row">
                  <div class="d-flex justify-content-center justify-content-lg-end">
                    <div
                      class="dataTables_paginate paging_simple_numbers"
                    >
                      <!-- pagination -->
                      <b-pagination
                        class="pagination-rounded"
                        v-model="pCurrentPage"
                        :total-rows="productTotal"
                        :per-page="pPerPage"
                        @change="pCurrentPage = $event;getProductList()"

                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end pagination -->
          </b-tab><!--Product List-->
        </b-tabs>
      </div>
    </div>
  </div> <!-- end of outer div-->
</template>

<style>
</style>